import {EntityFollowedEvent} from './EntityFollowedEvent';

export class ProfileFollowed extends EntityFollowedEvent {}
